import { useState, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useBranding } from '../../contexts/BrandingContext';
import { SeracGlyph } from '../serac';

interface MarketingHeaderProps {
  rightContent?: ReactNode;
}

export default function MarketingHeader({ rightContent }: MarketingHeaderProps) {
  const { branding } = useBranding();
  const isCustomBranded = branding.type !== null;

  const [logoError, setLogoError] = useState(false);

  const hasLogo = isCustomBranded && branding.logoUrl && !logoError;
  const hasBrandName = branding.brandName && branding.brandName.trim() !== '';
  const logoOnlyMode = hasLogo && !hasBrandName;

  return (
    <header className="px-4 py-4 border-b border-gray-200">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          {hasLogo ? (
            <img
              src={branding.logoUrl}
              alt={branding.brandName || branding.name}
              className={logoOnlyMode ? "h-10 object-contain" : "h-8 w-8 object-contain"}
              onError={() => setLogoError(true)}
            />
          ) : isCustomBranded ? (
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-sm"
              style={{ backgroundColor: branding.primaryColor }}
            >
              {(branding.brandName || branding.name).charAt(0).toUpperCase()}
            </div>
          ) : (
            <SeracGlyph size={32} color="var(--ice-500)" />
          )}
          {!logoOnlyMode && (
            <span className="font-bold text-lg text-gray-900" style={{ fontFamily: 'var(--font-display)', fontWeight: 500 }}>
              {isCustomBranded ? (
                <span style={{ color: branding.primaryColor }}>
                  {branding.brandName || branding.name}
                </span>
              ) : (
                <span style={{ color: 'var(--fg)' }}>serac</span>
              )}
            </span>
          )}
        </Link>
        <div className="flex items-center gap-4">
          {rightContent}
        </div>
      </div>
    </header>
  );
}
